angular.module('zc.projects')

.directive 'visitorSegmentSelector', ($modal, $translate, Image, ProjectVisitorSegment, lib) ->
  restrict: 'E'
  scope:
    visitorSegmentIds: '='
    disabled: '='
  template: """
    <select
      class="multi-select"
      style="width: 100%"
      ng-model="visitorSegmentIds"
      name="visitor_segment_selector"
      multiple="true">
    </select>
  """
  link: (scope, element, attrs) ->
    element = element.children('select')
    ProjectVisitorSegment.all(scope.$parent.project.id).then (res) ->
      allSegments = res
      allSegmentIds = _.map allSegments, (visitorSegment) ->
        visitorSegment.id.toString()
      if scope.disabled in ['true', true]
        availableVisitorSegmentIds = scope.visitorSegmentIds
        element.prop('disabled', true)
      else
        availableVisitorSegmentIds = allSegmentIds

      data = _.map availableVisitorSegmentIds, (visitorSegmentId) -> {
        id: visitorSegmentId,
        text: _.find(allSegments, id: parseInt(visitorSegmentId)).name,
        selected: _.includes(scope.visitorSegmentIds, visitorSegmentId)
      }

      element.select2({
        data: data
      })



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/visitor_segment_selector.coffee